export type AssetsHistoryQueryParams = {
  plantId: string
  from: string
  to: string
}

export const getAssetsHistoryPath = (plantId: string): string => `/plants/${plantId}/assets/history`
